import { render, staticRenderFns } from "./AdminAcademicSubcategoriesEdit.html?vue&type=template&id=7cd06df0&scoped=true&"
import script from "./AdminAcademicSubcategoriesEdit.vue?vue&type=script&lang=js&"
export * from "./AdminAcademicSubcategoriesEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdminAcademicSubcategoriesEdit.scss?vue&type=style&index=0&id=7cd06df0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd06df0",
  null
  
)

export default component.exports